import { required, email } from './../../lib/utils/validations';

const passwordResetValidation = (data) => {
  return {
    email: [required, email],
  };
};

export default passwordResetValidation;
